import React from 'react'

const Loader = () => {
  return (
    <div className="loader-grid">
        <div className='loader'>
        </div>
    </div>

  )
}
 
export default Loader
